import React from "react";

export function AppModalView({ modal, onClose }) {
  const [value, setValue] = React.useState(modal.defaultValue || "");
  const inputRef = React.useRef(null);
  const titleId = React.useId ? React.useId() : "modal-title";

  React.useEffect(() => {
    // Auto-focus input on prompt, or the confirm button on confirm
    setTimeout(() => {
      if (modal.type === 'prompt' && inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, 50);
    const onKey = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); onClose(); }
      if (e.key === 'Enter' && modal.type === 'confirm') {
        e.preventDefault();
        modal.onConfirm?.();
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [modal, onClose]);

  const submit = () => {
    if (modal.type === 'prompt') modal.onConfirm?.(value);
    else modal.onConfirm?.();
    onClose();
  };

  return (
    <div role="dialog" aria-modal="true" aria-labelledby={titleId}
      onClick={onClose}
      style={{position:"fixed",inset:0,background:"rgba(2,6,23,0.75)",zIndex:2000,
        display:"flex",alignItems:"center",justifyContent:"center",padding:16,
        backdropFilter:"blur(4px)",animation:"fadeIn 0.15s ease"}}>
      <div onClick={(e)=>e.stopPropagation()}
        className="modal-fade-in"
        style={{background:"#0f172a",
          border:`1px solid ${modal.danger?"rgba(185,28,28,0.4)":"rgba(30,58,95,0.8)"}`,
          borderRadius:14,
          padding:"24px 24px 20px",width:"100%",maxWidth:420,
          boxShadow:"0 24px 64px rgba(0,0,0,0.7)",
          fontFamily:"'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>
        {modal.danger && (
          <div style={{width:36,height:36,borderRadius:10,background:"rgba(185,28,28,0.12)",
            border:"1px solid rgba(185,28,28,0.3)",display:"flex",alignItems:"center",
            justifyContent:"center",marginBottom:14}}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></div>
        )}
        <h3 id={titleId} style={{margin:"0 0 8px",fontSize:15,fontWeight:700,letterSpacing:"-0.2px",
          color: modal.danger ? "#fca5a5" : "#f1f5f9"}}>
          {modal.title}
        </h3>
        {modal.body && (
          <p style={{margin:"0 0 18px",color:"#64748b",fontSize:13,lineHeight:1.6}}>
            {modal.body}
          </p>
        )}
        {modal.type === 'prompt' && (
          <input ref={inputRef} type="text" value={value}
            onChange={(e)=>setValue(e.target.value)}
            onKeyDown={(e)=>{ if(e.key==='Enter'){ e.preventDefault(); submit(); } }}
            placeholder={modal.placeholder || ""}
            aria-label={modal.title}
            style={{width:"100%",padding:"10px 13px",background:"#020617",
              border:"1px solid #334155",borderRadius:8,color:"#f1f5f9",
              fontSize:13,fontFamily:"inherit",marginBottom:18,outline:"none",
              transition:"border-color 0.15s,box-shadow 0.15s"}}/>
        )}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button onClick={onClose}
            style={{padding:"9px 18px",background:"transparent",color:"#94a3b8",
              border:"1px solid #334155",borderRadius:8,cursor:"pointer",fontSize:13,
              fontFamily:"inherit",fontWeight:500,transition:"all 0.15s"}}
            onMouseEnter={e=>{e.currentTarget.style.background="rgba(255,255,255,0.05)";e.currentTarget.style.color="#f1f5f9";}}
            onMouseLeave={e=>{e.currentTarget.style.background="transparent";e.currentTarget.style.color="#94a3b8";}}>
            {modal.cancelLabel || "Cancel"}
          </button>
          <button onClick={submit} autoFocus={modal.type === 'confirm'}
            style={{padding:"9px 18px",
              background: modal.danger ? "linear-gradient(135deg,#b91c1c,#dc2626)" : "linear-gradient(135deg,#1d4ed8,#4338ca)",
              color:"#fff",border:"none",borderRadius:8,cursor:"pointer",
              fontSize:13,fontFamily:"inherit",fontWeight:600,
              boxShadow: modal.danger ? "0 2px 8px rgba(185,28,28,0.35)" : "0 2px 8px rgba(29,78,216,0.35)",
              transition:"all 0.15s"}}
            onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-1px)";e.currentTarget.style.boxShadow=modal.danger?"0 4px 14px rgba(185,28,28,0.5)":"0 4px 14px rgba(29,78,216,0.5)";}}
            onMouseLeave={e=>{e.currentTarget.style.transform="none";}}>
            {modal.confirmLabel || (modal.type === 'prompt' ? "OK" : "Confirm")}
          </button>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// DEMO CV  (blank starter for new users)
// ══════════════════════════════════════════════════════════════════════════════
